var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-container"},[_c('el-table',{attrs:{"data":_vm.steps,"header-cell-style":{'text-align':'center'},"cell-style":{'text-align':'center'},"border":""}},[_c('el-table-column',{attrs:{"prop":"step","label":"目标"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"目标值"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09beccae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/my-store/salary-commisson/CmiStepFrom.vue
// module id = null
// module chunks = 